import { render, staticRenderFns } from "./CalibrationColour.vue?vue&type=template&id=59684363"
import script from "./CalibrationColour.vue?vue&type=script&lang=js"
export * from "./CalibrationColour.vue?vue&type=script&lang=js"
import style0 from "./CalibrationColour.vue?vue&type=style&index=0&id=59684363&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports